import { Select } from "@material-ui/core";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import styled from "styled-components";

export const Nav = styled.nav`
  background: #fff;
  height: 90px;
  /* margin-top: -100px; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1300px;
`;

export const NavLogo = styled(LinkR)`
  color: #fff;
  width: 100px;
  height: 60px;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
`;

export const LogoImg = styled.img`
  width: 100%;
  margin-top: 25px;
  object-fit: contain;
  @media screen and (max-width: 2000px) {
    display: block;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const FlagImg = styled.img`
  width: 30px;
  height: 30px;
`;

export const FlagSelect = styled(Select)`
  @media screen and (max-width: 768px) {
    margin-right: 50px;
    margin-bottom: 16px;
  }
`;

export const MobileLogoImg = styled.img`
  width: 90px;
  margin-top: 20px;
  object-fit: contain;
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #742f8a;
  }
`;

export const NavMenu = styled.ul`
  color: black;
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -10px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled(LinkS)`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 500;

  &.active {
    border-bottom: 3px solid #742f8a;
  }
`;
